import { get, post } from '../../../services/request';

export const fetchSchedulingCalendar = (payload) =>
    post('SchedulingCalendar/GetShifts', payload);

export const fetchSchedulingCalendarMetadata = () =>
    Promise.all([
        get('Task/GetAllTask?includeTaskTimes=false').catch(() => ({ values: {} })),
        get('Radiologist/GetAllRadiologistQgendaScheduleEnterpriseDropdown').catch(
            () => ({ values: {} }),
        ),
    ]);

export const fetchSchedulingCalendarTaskDetails = async (taskId) => {
    const response = await get(`Task/GetTaskByID?taskID=${encodeURIComponent(taskId)}`);
    if (response?.success === false || response?.Success === false) {
        throw new Error(response?.errorMessage || response?.ErrorMessage || 'Failed to load task details.');
    }
    return response?.value || response?.Value || response?.values || response?.Values || response;
};

export const saveSchedulingCalendarShift = (payload) =>
    post('SchedulingCalendar/SaveShift', payload);

export const deleteSchedulingCalendarShift = (shiftId) =>
    post('SchedulingCalendar/DeleteShift', { ShiftInputDetailID: shiftId });

export const fetchSchedulingCalendarAdhocDropdowns = () =>
    get('SchedulingCalendar/GetAdhocDropdowns?includeTaskTimes=false');

export const saveSchedulingCalendarAdhocShifts = (payload) =>
    post('SchedulingCalendar/SaveAdhocShifts', payload);

export const generateSchedulingCalendarShifts = (payload) =>
    post('SchedulingCalendar/GenerateSchedules', payload);

export const createSchedulingCalendarSharableLink = (payload) =>
    post('SchedulingCalendar/CreateSharableLink', payload);

export const sendSchedulingCalendarSharableLinkEmail = (payload) =>
    post('SchedulingCalendar/SendSharableLinkEmail', payload);

export const fetchSchedulingCalendarSharableLinks = () =>
    post('SchedulingCalendar/GetSharableLinks', {});

export const fetchSchedulingCalendarSharableLinkEmailAudit = (sharableLinkId) =>
    post('SchedulingCalendar/GetSharableLinkEmailAuditLog', { SharableLinkID: sharableLinkId });

export const deleteSchedulingCalendarSharableLink = (sharableLinkId) =>
    post('SchedulingCalendar/DeleteSharableLink', { SharableLinkID: sharableLinkId });

export const updateSchedulingCalendarSharableLinkDateRange = (payload) =>
    post('SchedulingCalendar/UpdateSharableLinkDateRange', payload);

export const getEmailTemplateByCategory = (categoryCode) =>
    get(`Common/GetEmailTemplateByCategory?CategoryCode=${encodeURIComponent(categoryCode || '')}`);

export const fetchTaskFacilities = (taskId) =>
    get(`Task/GetTaskFacilities?taskId=${encodeURIComponent(taskId)}`);